module.exports = "../static/media/banner_poster.49eeb8aa.png";